import actionCreatorFactory from 'typescript-fsa';
import { NAMESPACE } from './constants';
import { MyLoungeResponse } from '@shared/types/mylounge';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const fetchingCampaigns = actionCreator.async<null, MyLoungeResponse, string>(
    'FETCH_CAMPAIGNS'
);

export const updateImagesLoaded = actionCreator<boolean>(
    'UPDATE_IMAGES_LOADED'
);
